"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaxPaidStudies = exports.increasedMaxTipPercentage = exports.maxTipPercentageOfIncentive = exports.NewOrganizationServiceFee = exports.OversubscribedFactor = exports.TransactionFee = exports.SupportPrice = exports.MinimumIncentiveForReferral = exports.MinimumReferralFee = exports.MaxProjectReferrals = exports.MinResearcherReferralSpend = exports.ResearcherReferralFee = exports.profileLockTimeInDays = exports.ProjectDelayVisibility = exports.SignupReferralEarnedIncentiveThreshold = exports.SignupReferralFee = exports.ReferralFee = exports.DefaultPicture = exports.DefaultTimezone = void 0;
exports.DefaultTimezone = 'America/New_York';
exports.DefaultPicture = 'https://s3.amazonaws.com/respondentinc-images/assets/user_avatar_128.png';
exports.ReferralFee = 50;
exports.SignupReferralFee = 20;
exports.SignupReferralEarnedIncentiveThreshold = 75;
exports.ProjectDelayVisibility = 1;
exports.profileLockTimeInDays = 7;
exports.ResearcherReferralFee = 500;
exports.MinResearcherReferralSpend = 200;
exports.MaxProjectReferrals = 5;
exports.MinimumReferralFee = 21;
exports.MinimumIncentiveForReferral = 100;
exports.SupportPrice = 99;
exports.TransactionFee = 1.03;
exports.OversubscribedFactor = 5;
exports.NewOrganizationServiceFee = 0.5;
exports.maxTipPercentageOfIncentive = 0.25;
exports.increasedMaxTipPercentage = 2;
// Possibly in need of removal:
exports.MaxPaidStudies = 5;
